/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Supported browser names for browser detection.
 * Covers legacy (IE, Opera legacy, Edge Legacy) through modern browsers
 * and mobile-specific variants (Chrome iOS, Firefox iOS).
 */
export enum BrowserName {
  // Modern desktop/mobile browsers
  Chrome = "Chrome",
  Firefox = "Firefox",
  Safari = "Safari",
  Edge = "Edge", // Chromium-based Edge (Edg/)
  EdgeLegacy = "Edge Legacy", // EdgeHTML engine (Edge/)
  Opera = "Opera", // Modern OPR/ and legacy Opera/
  // Mobile-specific browser variants
  ChromeIOS = "Chrome iOS", // CriOS/ on iOS
  FirefoxIOS = "Firefox iOS", // FxiOS/ on iOS
  // OEM / regional browsers
  Samsung = "Samsung Internet", // SamsungBrowser/
  UCBrowser = "UC Browser", // UCBrowser/
  Yandex = "Yandex", // YaBrowser/
  // Legacy browsers
  IE = "Internet Explorer", // MSIE or Trident/
  // Fallback
  Unknown = "Unknown"
}
